import './App.scss';
import Landing from './components/landing/Landing.js';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Footer from './components/landing/footer/Footer.js';
import Loader from './hooks/Loader.js';
import { useEffect, useState } from 'react';
import Navbar from './components/landing/header/Navbar.js';



function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isFirstVisit = !localStorage.getItem("hasVisited");

    const timeout = setTimeout(() => {
      setLoading(false);
      localStorage.setItem("hasVisited", "true");
    }, isFirstVisit ? 6000 : 2000);

    return () => clearTimeout(timeout);
  }, []);
  return (
    <>
      <Router>
      
        <Switch>
          <Route exact path='/' component={Landing} />
        </Switch>
        <Footer />
      </Router>
    </>
  );
}

export default App;




